import { useEffect, useRef, useState } from 'react';
const INITIAL_DIMENSIONS = {
  plotHeight: 100,
  plotWidth: 100,
  margin: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }
};

// This function is used to detect the correct size to be passed
// to the pure chart components.
export function DimensionsWrapper(_ref) {
  let {
    children
  } = _ref;
  const [, forceUpdate] = useState({});
  const dimensions = useRef(INITIAL_DIMENSIONS);
  const plotSvgRef = useRef(null);

  // Update the dimensions and margin when the SVG element is resized.
  useEffect(() => {
    const resizeObserverSvg = new ResizeObserver(entries => {
      if (entries && entries[0]) {
        const {
          width: ws,
          height: hs
        } = entries[0].target.getBoundingClientRect();
        const newMargin = Object.assign({}, dimensions.current.margin);
        dimensions.current = {
          margin: newMargin,
          plotHeight: hs,
          plotWidth: ws
        };
        forceUpdate({});
      }
    });

    // If parentDiv is available, observe it and its axis-left child (if exists).
    // If not, disconnect the observers.
    if (plotSvgRef.current) {
      resizeObserverSvg.observe(plotSvgRef.current);
    }
    return () => {
      resizeObserverSvg.disconnect();
    };
  }, []);
  return children({
    ...dimensions.current,
    plotSvgRef
  });
}